import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { watchEntireCollection } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { gateNexusSubscription } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { switchMap } from 'rxjs';
import { AgentWhitelistEntry } from '../entities/AgentWhitelistEntry.js';
import { WhitelistEntry } from '../entities/WhitelistEntry.js';

async function loadTicketWhitelistEntries(): Promise<WhitelistEntry[]> {
  const col = await getRawCollection<EntityData<WhitelistEntry>>(WhitelistEntry._collectionName);
  const docs = await col.find({}).toArray();
  return docs.map(doc => new WhitelistEntry(doc as EntityData<WhitelistEntry>));
}

async function loadAgentWhitelistEntries(): Promise<AgentWhitelistEntry[]> {
  const col = await getRawCollection<EntityData<AgentWhitelistEntry>>(AgentWhitelistEntry._collectionName);
  const docs = await col.find({}).toArray();
  return docs.map(doc => new AgentWhitelistEntry(doc as EntityData<AgentWhitelistEntry>));
}

export const subscribeWhitelistTicketEntries = registerSubscription({
  operationName: 'subscribeWhitelistTicketEntries',
  type: () => [WhitelistEntry],
  params: [],
  resolve: () => (_gqlFields: BaseQLSelectionSet<WhitelistEntry>) =>
    gateNexusSubscription(NexusPermission.WhitelistManage, () =>
      watchEntireCollection(WhitelistEntry._collectionName).pipe(switchMap(loadTicketWhitelistEntries)),
    ),
});

export const subscribeWhitelistAgentEntries = registerSubscription({
  operationName: 'subscribeWhitelistAgentEntries',
  type: () => [AgentWhitelistEntry],
  params: [],
  resolve: () => (_gqlFields: BaseQLSelectionSet<AgentWhitelistEntry>) =>
    gateNexusSubscription(NexusPermission.WhitelistManage, () =>
      watchEntireCollection(AgentWhitelistEntry._collectionName).pipe(switchMap(loadAgentWhitelistEntries)),
    ),
});
